<app-dashboard>
    <div class="w-full flex flex-col p-[20px]">
        <div class="w-full mb-[20px]"><span class="font-[500] text-[20px] text-slate-600">Welcome,  <span class="text-[24px] font-[800] text-slate-800">{{activeBusinessname}}</span></span></div>
        <div class="w-full gap-[20px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[12px] font-[500]"> No. of Customers</span>
                <span class="text-[30px] font-[800] text-slate-900">93</span>
            </div>
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[12px] font-[500]"> No. of Rewards</span>
                <span class="text-[30px] font-[800] text-slate-900">380</span>
            </div>
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[12px] font-[500]"> No. of Disbursed Rewards</span>
                <span class="text-[30px] font-[800] text-slate-900">310</span>
            </div>
            <div class="w-full flex flex-col gap-[8px] border rounded-[8px] p-[15px]">
                <span class="text-[#6B7280] text-[12px] font-[500]"> No. Points Given</span>
                <span class="text-[30px] font-[800] text-slate-900">1,050</span>
            </div>
        </div>
      <div class="w-full flex flex-col lg:grid lg:grid-cols-2 gap-[20px]">
        <div class="w-full col-span-1 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Amount for Each Reward Type</span>
            <canvas id="barChart"></canvas>
          </div>
          <div class="w-full col-span-1 flex flex-col gap-[25px] mt-[20px] p-[15px] border rounded-[8px]">
            <span class="text-slate-600 text-[14px] font-[500]">Total Rewards</span>
            <canvas id="lineChart"></canvas>
          </div>
      </div>
    </div>
</app-dashboard>
